import React from 'react'
import "./ProductItem.css"
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';
function ProductItem({ product }) {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const priceAfterPrec = product?.discounted_price_egp * 100
  const prec = 100 - (priceAfterPrec / product?.price_egp)
  return (
    <Link to={`/product/${product?.id}`}>
      <div className='mb-3 border rounded'
    style={{
      height: "350px",
    }}
      >
        <div className='img_container'>
          <img src={product?.images[0]?.image} alt='' className='w-100 h-100 product_img' />
    {product && product?.discounted_price_egp!=0
      &&
            <div className=' d-flex'>
            <p
              className='bg-danger text-white rounded py-1 px-2'
              style={{ position: "absolute", top: 0 }}
            >{prec.toFixed(2)}%</p>
          </div>
    }
        </div>
        <div className='px-2 py-2'>
          <p className='product_name mb-1 px-3'>{currentLocal.language === "English" ? product?.name_en : product?.name_ar}</p>
          <p
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontWeight: "normal",
              lineHeight: "24px"
            }}
            className="product_name mb-1 px-3"
          >
            {currentLocal.language === "English"
              ? product?.description_en
              : product?.description_ar}
          </p>
          {/* <p className='product_price px-3 '>{product?.price_egp} {"EGP"}</p> */}
          <div className='d-flex align-items-center mt-3 mb-2'>
            {product && product?.discounted_price_egp!=0 ?
              <>
                <p className='mb-0 price text-decoration-line-through'>LE {Number(product && product?.price_egp).toFixed(2)}</p>
                <p className='mb-0 price mx-2 fs-6 fw-bold'>LE {Number(product && product.discounted_price_egp).toFixed(2)}</p>
              </>
              :
              <p className='mb-0 price_discount'>LE {Number(product && product.price_egp).toFixed(2)} </p>

            }
          </div>

        </div>
      </div>
    </Link>
  )
}

export default ProductItem